const type = 'SET_CANCEL_INVOICE_INSTALLMENT_ERROR';

const setCancelInvoiceInstallmentError = (data = {}) => ({
  data,
  type,
});

export { type };
export default setCancelInvoiceInstallmentError;
